import { render } from "./download.vue?vue&type=template&id=14227f06&scoped=true"
const script = {}

import "./download.vue?vue&type=style&index=0&id=14227f06&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14227f06"]])

export default __exports__